/** biome-ignore-all lint/correctness/useHookAtTopLevel: the platform and workspace do not change while mounted */
import Workspace from "@core-ui/ContextServices/Workspace";
import { usePlatform } from "@core-ui/hooks/usePlatform";

export const useIsQuizEnabled = () => {
	const { isNext } = usePlatform();
	if (!isNext) return false;
	const enterprise = Workspace.current()?.enterprise;
	return !!enterprise?.gesUrl && !!enterprise.modules?.quiz;
};
